import { historicalSource } from '../history/sources';
import { createElement, setText } from './dom';

export function createHistoricalSource(parent: HTMLElement, opened?: () => void) {
  const root = createElement('details', 'historical-source', parent);
  root.hidden = true;
  const toggle = createElement('summary', 'historical-source-toggle', root);
  setText(toggle, 'Historical source');
  const body = createElement('div', 'historical-source-note', root);
  const title = createElement('cite', 'historical-source-title', body);
  const publisher = createElement('p', 'historical-source-publisher', body);
  const note = createElement('p', 'historical-source-text', body);
  let current: string | null = null;
  root.addEventListener('toggle', () => {
    if (root.open) opened?.();
  });
  return {
    set(url: string | null): void {
      if (url === current) return;
      current = url;
      root.open = false;
      root.hidden = !url;
      if (!url) return;
      const source = historicalSource(url);
      title.textContent = source.title;
      publisher.textContent = source.publisher;
      setText(note, source.note.en);
    },
    close(): void {
      root.open = false;
    },
  };
}
